import { ImageComponent } from 'BreetComponents';
import { useModalApi, useQRCode } from 'BreetHooks';

export const DialogQrCode = () => {
	const { getModalProps } = useModalApi();

	const { metadata } = getModalProps('qrCode') as { metadata?: { url?: string } };

	const { qrCode } = useQRCode({ address: metadata?.url });

	return (
		<div className='qr-code-modal bg-primary-400'>
			<ImageComponent
				src={qrCode}
				alt='QR Code'
			/>
		</div>
	);
};
